import i18next from 'i18next';

export function useTranslate() {
  function t(key, options = {}) {
    return i18next.t(key, options);
  }

  return { t };
}
